import { useSelector } from 'react-redux';
import { Link } from 'react-router';

import appSelectors from '@/redux/app/appSelectors';

import useMatchMedia from '@/hooks/useMatchMedia';
import RouteNames from '@/router/routes';

import right from '@/images/sectionFourTypesPartnerProgram/right.svg';

import Container from '@/components/container';
import DiscountTicker from '@/components/discountTicker';
import Rubricator from '@/components/rubricator';

import s from './sectionFourTypesPartnerProgram.module.css';

function SectionFourTypesPartnerProgram() {
  const i18n = useSelector(appSelectors.translation);

  const { isDesktop } = useMatchMedia();

  return (
    <section className={s.section}>
      <DiscountTicker discount1={'15'} discount2={'20'} discount3={'25'} />

      <Container>
        <div className={s.marker_title_wrapper}>
          <Rubricator
            single={isDesktop ? i18n.партнерская_программа : i18n.партнерка}
          />
          <p className={s.title}>
            {i18n.четыре_вида}
            <br />
            {i18n.партнерской}
            <br />
            {i18n.программы}
          </p>
        </div>

        <ul className={s.types_list}>
          <li>
            <Link to={`/${RouteNames.PARTNER_CLASSIC}`} className={s.link}>
              <div className={s.name}>
                <p>{i18n.Классическая_CPS}</p>
                <img src={right} alt="right" />
              </div>
              <p className={s.text}>
                {i18n.Платим_15_с_каждого_платежа}
                <br />
                {i18n.привлеченного_клиента}
              </p>
            </Link>
          </li>
          <li>
            <Link to={`/${RouteNames.PARTNER_MULTILEVEL}`} className={s.link}>
              <div className={s.name}>
                <p>{i18n.Мультилевел}</p>
                <img src={right} alt="right" />
              </div>
              <p className={s.text}>
                {i18n.Многоуровневая_программа_для_партнеров}
              </p>
            </Link>
          </li>
          <li>
            <Link to={`/${RouteNames.WHITE_LABEL}`} className={s.link}>
              <div className={s.name}>
                <p>White Label</p>
                <img src={right} alt="right" />
              </div>
              <p className={s.text}>{i18n.Комплексное_решение_для}</p>
            </Link>
          </li>
          <li>
            <Link to={`/${RouteNames.RESALE}`} className={s.link}>
              <div className={s.name}>
                <p>{i18n.Реселлинг}</p>
                <img src={right} alt="right" />
              </div>
              <p className={s.text}>{i18n.Хотите_сдавать_в_аренду}</p>
            </Link>
          </li>
        </ul>
      </Container>
    </section>
  );
}

export default SectionFourTypesPartnerProgram;
